import { directionArr } from "../configParams";

export const randomDirArrGenerator = () => {
  const proofArr = [];
  directionArr.forEach((dir) => {
    const randomValue =
      directionArr[Math.floor(Math.random() * directionArr.length)];
    proofArr.push(randomValue);
  });

  return proofArr;
};
